// Vue
import Vue from 'vue'
import App from './App'
// 核心插件
import d2Admin from '@/plugin/d2admin'
import 'amfe-flexible'
// store
import store from '@/store/index'
// 多国语
import i18n from './i18n'
import { getmenus } from '@/api/menu'
// 菜单和路由设置
import { getDynamicMenu } from '@api/menu'
import router from './router'
// import menuHeaderPromise from '@/menu/header'
// import menuAsidePromise from '@/menu/aside'
import { frameInRoutes } from '@/router/routes'
import util from '@/libs/util.js'
import VueCropper from 'vue-cropper'
import VCharts from 'v-charts'
import echarts from 'echarts'
import bmap from 'vue-baidu-map'
import { mapState, mapActions } from 'vuex'

import 'xe-utils'
import VXETable from 'vxe-table'
import 'vxe-table/lib/style.css'
import '@/assets/public.scss'
import clipboard from 'vue-clipboard2' // 剪贴板
import '@/assets/style/element-variables.scss'
import { Gtoken } from '@/config/index.js'
Vue.use(VXETable)
Vue.prototype.$echarts = echarts
Vue.use(VCharts)
Vue.use(clipboard) // 剪贴板

// 核心插件
Vue.use(d2Admin)
// 图片裁剪
Vue.use(VueCropper)
Vue.use(bmap, {
  al: 'PlhFWpA02aoURjAOpnWcRGqw7AI8EEyO'
})

Vue.prototype.$hasPermission = per => {
  const permissions = ['default', ...store.getters['d2admin/user/permission']]

  return permissions.includes(per)
}
Vue.filter('thousandsSeparator', function (value) {
  
  if (!value) return '0'
  return Number(value).toString().replace(/(\d)(?=(\d{3})+\.)/g, function ($0, $1) {
    return $1 + ','
  })
})

Vue.directive('demo', function (el, binding) {
  // 根据需求使用动态路由的权限，这里先取消
  // const pris = store.getters['d2admin/menu/usertokens']

  // if (!pris.includes(binding.value)) {
  //   el.innerHTML = "<div style='width: 200px;text-align:center;margin:0  auto;margin-top: calc(100vh/2 - 200px)'><img style='width: 270px' src='https://xgzh-fe.oss-cn-hangzhou.aliyuncs.com/xg-web-operate/images/common/sigoran_nopermission.png'/><p  style='text-align:center;width: 270px;font-size: 16px;color: #8A96A3' >暂无权限</p></div>"
  // }
})

// 针对个别页面没有权限时的处理
Vue.directive('permission', function (el, binding) {
  const permission = store.getters['d2admin/menu/usertokens']
  if (!permission.includes(binding.value)) {
    el.style.cssText = "height: 100%; display: flex; flex-flow: row nowrap; justify-content: center; align-items: center; background: #fff;"
    el.innerHTML = "<div id='directive-no-permission'><img src='https://xgzh-fe.oss-cn-hangzhou.aliyuncs.com/xg-web-operate/images/common/sigoran_nopermission.png'/><p style='font-size: 16px; color: #8A96A3; text-align: center;'>暂无权限</p></div>"
  }
})
window.addEventListener("visibilitychange", function () {
  if (document.hidden == false && Gtoken.aaa != util.cookies.get('token')) {
    router.go(0)

  }
})
new Vue({
  router,
  store,
  i18n,
  render: h => h(App),
  computed: {
    ...mapState('d2admin/menu', ['header', 'asideList'])
  },
  async created() {
    // this.$s
    // 处理路由 得到每一级的路由设置
    this.$store.commit('d2admin/page/init', frameInRoutes)
    // const that = this
    // const token = util.cookies.get('token')
    // if (token) {
    //   await getmenus().then(res => {
    //     that.$store.commit('d2admin/menu/authSet', res.permissions)
    //   })
    // }

    // 获取动态菜单
    await this.getDynamicMenu()
    // 设置顶栏菜单
    this.$store.commit('d2admin/menu/headerSet', this.header)
    // 设置侧边栏菜单
    // this.$store.commit('d2admin/menu/asideSet', menuAside)
    // 初始化菜单搜索功能
    //  console.log(token)

    this.$store.commit('d2admin/search/init', this.header)
  },
  mounted() {
    // 展示系统信息
    this.$store.commit('d2admin/releases/versionShow')
    // 用户登录后从数据库加载一系列的设置
    this.$store.dispatch('d2admin/account/load')
    // 获取并记录用户 UA
    this.$store.commit('d2admin/ua/get')
    // 初始化全屏监听
    this.$store.dispatch('d2admin/fullscreen/listen')
  },
  watch: {
    // 检测路由变化切换侧边栏内容
    '$route.matched': {
      async handler(matched) {
        if (this.asideList.length === 0) {
          await this.getDynamicMenu()
        }
        // console.log(matched, '路由变了')
        if (matched.length > 0) {
          const _side = this.asideList.filter(menu => menu.path === matched[0].path)
          // console.log(_side, '获取的')
          this.$store.commit(
            'd2admin/menu/asideSet',
            _side.length > 0 ? _side[0].children : []
          )
        }
      },
      // handler(matched) {
      //   if (matched.length > 0) {
      //     // 设置侧边栏
      //     let asideList = JSON.parse(localStorage.getItem("d2admin-asideList")) || []
      //     
      //     const _side = matched[0].path == '' ? asideList.filter(menu => menu.path === matched[1].path) : asideList.filter(menu => menu.path === matched[0].path)
      //     this.$store.commit('d2admin/menu/asideSet', _side.length > 0 ? _side[0].children : [])
      //   }
      // },
      immediate: true
    },
    'Gtoken.aaa': 'refresh'
  },
  methods: {
    ...mapActions('d2admin/page', ['close']),
    // 关闭当前
    closePageTop(routerParams, tagName = this.$route.fullPath) {
      this.close({
        tagName,
        routerParams
      })
    },
    // 获取动态菜单
    async getDynamicMenu() {
      const token = util.cookies.get('token')
      if (token) {
        await getDynamicMenu().then(res => {
          this.$store.commit('d2admin/menu/menuListSet', res.menuList)

          localStorage.setItem("d2admin-admin-notAvailablePermissions", JSON.stringify(res.notAvailablePermissions))
          if(res.notAvailablePermissions.includes(this.$route.fullPath)){
            router.push('/noPermission')
          }
        })
      }
    },
    refresh() {
      console.log('重新登录了MAIN')
      // this.$router.push({
      //   path: '/index'
      // })

    }
  }
}).$mount('#app')
